import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";

export const EnglishRoutes = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);

  if (language !== "en") {
    return <Navigate to={`/${language}`} replace />;
  }

  return <Outlet />;
};
